import React from 'react';
import HTMLComponent from './HTMLComponent';
import { t, props } from 'tcomb-react';
import micromd from '../../micromd';

@props({
  children: t.Str
})

export default class MarkdownComponent extends React.Component {

  render() {
    if (!this.props.children) {
        return null
    }
    return (
      <HTMLComponent>
        {micromd(this.props.children)}
      </HTMLComponent>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/MarkdownComponent.js
 **/